import {
  FaHome,
  FaHammer,
  FaPaintRoller,
  FaWrench,
  FaWind,
} from "react-icons/fa";
import { AiFillSafetyCertificate } from "react-icons/ai";
import { GiBroom } from "react-icons/gi";
import { IoIosConstruct, IoIosRibbon } from "react-icons/io";

const Services = () => {
  return (
    <div className="servicescontainer">
      <div className="scrollcontrol" id="services"></div>
      <h1>Some of Our World Class Services</h1>
      <ul>
        <li>
          <div>
            <AiFillSafetyCertificate />
            <h5>INSURANCE CLAIMS</h5>
            <p>
              Roof damaged in a storm? Call us for a free 10 point inspection!
            </p>
          </div>
        </li>
        <li>
          <div>
            <FaHome />
            <h5>ROOFING & SIDING</h5>
            <p>Our experienced team is ready to work on your home.</p>
          </div>
        </li>
        <li>
          <div>
            <IoIosConstruct />
            <h5>REMODELS</h5>
            <p>
              That old kitchen or bathroom need a facelift? We've got you
              covered.
            </p>
          </div>
        </li>
        <li>
          <div>
            <FaPaintRoller />
            <h5>PAINTING</h5>
            <p>It's amazing what a fresh coat of paint can do.</p>
          </div>
        </li>
        <li>
          <div>
            <FaWrench />
            <h5>PREVENTATIVE MAINTENANCE</h5>
            <p>
              Don't wait until it's too late. Keep your systems running with
              proactive action.
            </p>
          </div>
        </li>
        <li>
          <div>
            <FaWind />
            <h5>DUCT REPAIR & INSTALLATION</h5>
            <p>Let us handle repairing or installing your duct work.</p>
          </div>
        </li>
        <li>
          <div>
            <GiBroom />
            <h5>DUCT CLEANING SERVICES</h5>
            <p>
              You'd be surprised with how dirty ducts can get! Clean the air you
              breath.
            </p>
          </div>
        </li>
        <li>
          <div>
            <IoIosRibbon />
            <h5>INDOOR AIR QUALITY ENHANCEMENTS</h5>
            <p>Get the best from your HVAC system.</p>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default Services;
